import { render, staticRenderFns } from "./BlockFixedpriceTicketProductInformation.vue?vue&type=template&id=09c45826&scoped=true&"
import script from "./BlockFixedpriceTicketProductInformation.vue?vue&type=script&lang=js&"
export * from "./BlockFixedpriceTicketProductInformation.vue?vue&type=script&lang=js&"
import style0 from "./BlockFixedpriceTicketProductInformation.vue?vue&type=style&index=0&id=09c45826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c45826",
  null
  
)

export default component.exports